import {IForm} from "~/cabinet/vue/interface/form/elements/Interfaces";
import Dictionary from "~/ts/library/Dictionary";
import {AttachmentsConfigModelInterface} from "~/cabinet/vue/interface/AttachmentsConfigInterface";
import {ComputedRef, InjectionKey} from "vue";
import {
    SenderContentFormModelInterface,
    SenderFormModelInterface
} from "~/cabinet/vue/client/sender/send/useSenderContentForm";
import {
    DiscountCouponFormInterface
} from "~/cabinet/vue/dealer/config/marketing/discountCoupon/DiscountCouponFormInterface";
import {FiltersModel} from "~/cabinet/vue/interface/filter/Interfaces";
import {WebhookConfigInterface} from "~/cabinet/vue/interface/webhook/WebhookConfigInterface";
import {DataSourceConfigInterface} from "~/cabinet/vue/client/dashboard/Interface";
import {IFilterValue} from "~/chat/ts/data/AutoActions";

export interface ICascadeContentFormEvent {
    eventDescriptionId: string,
    authId: string,
    platformId: string
}

export interface IFilterCascadeBlockParam {
    filters: IFilterCascadeBlockItemInterface[]
}

export interface IFilterCascadeBlockItemInterface {
    filterValues: any,
    outputId: string,
    descr: string
}

export const DELAY_ACTION_TYPE_DELAY = "delay";
export const DELAY_ACTION_TYPE_TIME_RANGE = "timeRange";
type DelayActionType = typeof DELAY_ACTION_TYPE_DELAY | typeof DELAY_ACTION_TYPE_TIME_RANGE;

export interface IDelayCascadeBlockParam {
    delay: number;
    timeRange: {
        start: string;
        stop: string;
    };
    type: DelayActionType
}

export interface ITargetCascadeBlockParam {
    outputNameForParentCascadeMessage?: string
}


export interface INoteCascadeBlockParam {
    text: string;
}

export interface ISenderCascadeBlockParam {
    senderFormParam: SenderFormModelInterface<any>
}

export interface IGlobalVarsBlockParam {
    vars: IGlobalVarsBlockParamVar[]
}

export interface IGlobalVarsBlockParamVar {
    key: string;
    value: string;
    randomMin: string;
    randomMax: string;
    dashboardDataSourceConfig: DataSourceConfigInterface;
    dashboardDateTimeFilters?: IFilterValue;
    type?: "math" | "random" | "dashboardValue";
}

export interface IWebhookCascadeBlockParam {
    globalVariables: {
        name: string,
        path: string[]
    }[],
    logId?: string;
    webhook: WebhookConfigInterface;
    descr?: string;
}

export interface OnlineChatShowAnimationBlockParamInterface {
    animationId: string;
}

export interface DiscountCouponBlockParam extends DiscountCouponFormInterface {

}

export interface ICallAlgoBlockParam {
    form: IForm
}

export interface ICabinetNotificationParam {
    subject: string;
    text: string;
}

export interface ISendNotificationToClientOnlineChatOperatorParam {
    text: string;
    dealerSiteId: string;
}

export interface ICascadeContentFormValue extends SenderContentFormModelInterface {
    schemeId: string;
}

export const ONLINE_CHAT_BOT_EVENT_DESCRIPTION_ID = "onlineChatBot";

export const CascadeContentFormEventInject = Symbol() as InjectionKey<ComputedRef<ICascadeContentFormEvent>>;

export interface IAbstractOnlineChatMessagePinParam {
    pinMessage: boolean;
    unpinOtherMessages: boolean;
    pinMessageForClient: boolean;
    unpinOtherMessagesForClient: boolean;
}

interface IAbstractOnlineChatMessageParam extends IAbstractOnlineChatMessagePinParam {
    text: string;
    isUseStandartContent: boolean;
    messageTypeId?: string;
}

export interface IOnlineChatMessageToOperatorParam extends IAbstractOnlineChatMessageParam {
    operators: (string | number)[],
    operatorsCount: string
}

export interface IOnlineChatForwardClientToOperatorParam {
    operators: (string | number)[];
    operatorsType: string;
    notifyToOperatorText?: string;
    notifyToClientText?: string;
    notifyToClientEnabled: boolean;
    virtualOperatorId?: string;
}

export interface OnlineChatUpdateDialogStatusParamInterface {
    statusId: string;
    markAsRead: boolean;
    removeFromBuddyList: boolean;
    isChangeAssigned: boolean;
    newAssignedOperatorLogins: string[];
    newAssignedOperatorGroups: string[];
}

export interface IOnlineChatRequestRateParam {
    customAnswerVariants: string[]
}

export const ONLINE_CHAT_MESSAGE_TO_CLIENT_SEND_ERROR_MESSAGE_AND_WAIT_FOR_VALID_ANSWER_ACTION_ID = "sendErrorMessageAndWaitForValidAnswer";

export interface IOnlineChatMessageToClientParam extends IAbstractOnlineChatMessagePinParam {
    text: string;
    unknownAnswerErrorText?: string,
    operatorType: string;
    virtualOperatorId: string;
    operatorLogin: string[];
    countInDialogStatistic: boolean;
    markPreviousMessagesAsReaded: boolean;
    answerVariants: AnswerVariantInterface[];
    waitingForClientAnswer: boolean;
    answerFilters: FiltersModel;
    messageOnValidateError?: string;
    messageOnValidateErrorAttachments: AttachmentsConfigModelInterface[];
    saveAnswerAsField?: string;
    useAnswerVariants: boolean;
    actionOnValidateError: string;
    attachments: AttachmentsConfigModelInterface[];
    withFilters: boolean;
    disableTextInput: boolean;
    contentVariants: OnlineChatMessageContentVariantInterface[];
}

export interface OnlineChatMessageContentVariantInterface {
    text: string;
    attachments: AttachmentsConfigModelInterface[];
}

export const ANSWER_VARIANT_TYPE_DEFAULT = "default";
export const ANSWER_VARIANT_TYPE_FAST_TRAVEL = "fastTravel";
export const ANSWER_VARIANT_TYPE_RETURN = "return";
export type AnswerVariantType =
    typeof ANSWER_VARIANT_TYPE_DEFAULT
    | typeof ANSWER_VARIANT_TYPE_FAST_TRAVEL
    | typeof ANSWER_VARIANT_TYPE_RETURN;
export const ANSWER_VARIANT_TYPES: { id: string, descr: string }[] = [
    {id: ANSWER_VARIANT_TYPE_DEFAULT, descr: "Простой ответ"},
    {id: ANSWER_VARIANT_TYPE_FAST_TRAVEL, descr: "Быстрый переход"},
    {id: ANSWER_VARIANT_TYPE_RETURN, descr: "К предыдущей точке возврата"},
];


export interface AnswerVariantInterface {
    typeId: AnswerVariantType;
    text?: string;
    fastTravelBlockId?: string;
}

export interface IOnlineChatRedirectParam {
    url: string,
}

export interface OnlineChatAiParamInterface {
    instructions: string;
    subject: string;
}

export interface OnlineChatAiChoiceParamInterface extends OnlineChatAiParamInterface {
    criteria: OnlienChatAiChoiceCriteriaInterface[];
}

export interface OnlienChatAiChoiceCriteriaInterface {
    id: string;
    descr: string;
}

export interface OnlineChatAiNoulParamInterface extends OnlineChatAiParamInterface {

}

export interface IOnlineChatCallGateParam {
    mobileText: string;
    text: string;
    rememberTtl: number;
}


export interface IOnlineChatOpenWidgetTabParam {
    tabId: string,
    tabShowTypeId: string,
    formValues: Dictionary<any>
}


export interface IPhonebookWithGroupSelectParam {
    groups: number[];
    groupIds: number[];
    isAllGroups: boolean;
}

export interface IEventAsActionParam {
    authPrimaryId: string,
    platformId: string,
    eventDescriptionId: string,
    eventIdentifiers: string[],
    eventFilters: Dictionary<any>
}

